import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import {
  MCGROtherConservationActivitiesControlName,
  MCGROtherConservationActivitiesFormGroup,
} from './other-conservation-activities-form-array.model';

@Injectable({
  providedIn: 'root',
})
export class MCGROtherConservationActivitiesFormArrayService {
  constructor(private formBuilder: UntypedFormBuilder) {}

  getFormGroup(): FormGroup<MCGROtherConservationActivitiesFormGroup> {
    return this.formBuilder.group({
      [MCGROtherConservationActivitiesControlName.Year]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGROtherConservationActivitiesControlName.ScopeOfWork]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGROtherConservationActivitiesControlName.Expenses]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGROtherConservationActivitiesControlName.PublicFundsSubsidies]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
    });
  }
}
